export default {
    SIMPLES: 1,
    ESTRUTURADO: 2,
}